import * as React from "react";
import { LiveTableBodyColumn } from "../LiveTableBodyColumn";
export const OnServeTeam1Scores = (props) => {
    const scoresProps = {
        teamName: props.teamName,
        scores: props.scores,
        onServe: props.onServe,
        teamSequence: "1",
        sportId: props.sportId
    };
    return React.createElement(OnServeTeamScores, Object.assign({}, scoresProps));
};
export const OnServeTeam2Scores = (props) => {
    const scoresProps = {
        teamName: props.teamName,
        scores: props.scores,
        onServe: props.onServe,
        teamSequence: "2",
        sportId: props.sportId
    };
    return React.createElement(OnServeTeamScores, Object.assign({}, scoresProps));
};
const OnServeTeamScores = (props) => {
    const { scores, teamName, teamSequence, onServe, sportId } = props;
    return (React.createElement("tr", { className: `rj-scoreboard__live-table-body-row rj-scoreboard__live-table-body-row--${sportId}`, "data-uat": "scoreboard-live-table-body-row" },
        React.createElement("td", { className: "rj-scoreboard__live-live-serve-indicator-wrapper" },
            React.createElement("div", { className: "rj-scoreboard__live-team-name-wrapper" },
                onServe && React.createElement("span", { className: getServiceClass(onServe, teamSequence), "data-uat": "scoreboard-live-serve-indicator" }),
                React.createElement("div", { className: "rj-scoreboard__live-team-name-container" },
                    React.createElement("span", { className: "rj-scoreboard__live-team-name" }, teamName)))),
        scores.map((value, index) => React.createElement(LiveTableBodyColumn, Object.assign({}, { value, index }, { key: `team-score-${index}` })))));
};
const getServiceClass = (onServe, teamSequence) => {
    return onServe === teamSequence
        ? `rj-scoreboard__live-serve-indicator rj-scoreboard__live-serve-indicator--active`
        : "rj-scoreboard__live-serve-indicator";
};
//# sourceMappingURL=OnServeTeamScores.js.map